import { createApp } from 'vue';
import ZipToTarConverter from '@/Components/ZipToTarConverter.vue';
import '@styles/app.css';

createApp(ZipToTarConverter).mount('#zip-to-tar-converter');
